import { render } from "./CourseOfUser.vue?vue&type=template&id=4fa30774&scoped=true"
import script from "./CourseOfUser.vue?vue&type=script&lang=js"
export * from "./CourseOfUser.vue?vue&type=script&lang=js"

import "./CourseOfUser.vue?vue&type=style&index=0&id=4fa30774&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa30774"]])

export default __exports__